import Vue from 'vue'
import TpSelect from '../components/select.vue'
import TpIcon from '../components/icon'

const components = [
  TpSelect,
  TpIcon
]

components.map(component => Vue.component(component.name, component))
